(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6438,2576,2597,5901,2472],{

/***/ 1842:
/***/ (function(module) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 66211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ healthcare; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(33420);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/Hero/assets/Hero.webp
var Hero = __webpack_require__(27871);
var Hero_default = /*#__PURE__*/__webpack_require__.n(Hero);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(2547);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/Hero/assets/HeroMobile@2x.png
var HeroMobile_2x = __webpack_require__(68068);
var HeroMobile_2x_default = /*#__PURE__*/__webpack_require__.n(HeroMobile_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/Hero/assets/HeroMobile.webp
var HeroMobile = __webpack_require__(43469);
var HeroMobile_default = /*#__PURE__*/__webpack_require__.n(HeroMobile);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/Hero/assets/HeroMobile@2x.webp
var assets_HeroMobile_2x = __webpack_require__(15883);
var assets_HeroMobile_2x_default = /*#__PURE__*/__webpack_require__.n(assets_HeroMobile_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/Hero/HeroImage.tsx













var HeroImage = function HeroImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var desktopResolutionMediaQuery = theme.breakpoints.up("lg", false);
  var isDesktop = (0,useMatchMedia/* default */.Z)(desktopResolutionMediaQuery, true);
  var _webp$webp2$png2$size = {
    webp: (HeroMobile_default()),
    webp2: (assets_HeroMobile_2x_default()),
    png2: (HeroMobile_2x_default()),
    size: [330, 487]
  },
      webp = _webp$webp2$png2$size.webp,
      webp2 = _webp$webp2$png2$size.webp2,
      png2 = _webp$webp2$png2$size.png2,
      size = _webp$webp2$png2$size.size;

  if (isDesktop) {
    webp = (Hero_default());
    webp2 = (assets_Hero_2x_default());
    png2 = (Hero_2x_default());
    size = [1128, 484];
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(webp, ", ").concat(webp2, " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
      width: size[0],
      height: size[1],
      src: png2,
      alt: "Hero"
    })]
  });
};

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "ewdi77b0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[1];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var Hero_HeroImage = (HeroImage);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var copy = {
  overline: "Healthcare",
  heading: "Use real-time data to deliver better outcomes across the care journey",
  description: "Segment makes it easy to build a robust data foundation in a HIPAA compliant manner, so you can focus on personalized interactions with patients, members and clinicians."
};
var FORM_ID = "healthcare-demo-request";

var Hero_Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroRecipeBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroRecipeForm, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
            isProgressive: true,
            customFormIdentifier: FORM_ID,
            customTrackingType: FORM_ID,
            successMessageAppearance: "twilioLight"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroRecipeContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroImage, {})
      })]
    })
  });
};

var HeroRecipeContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "e1i0xmei3"
} : 0)("padding-top:46px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:20px;}" + ( true ? "" : 0));

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1i0xmei2"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroRecipeBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1i0xmei1"
} : 0)(recipes_Hero/* Wrapper */.im, "{", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{padding-top:80px;}}" + ( true ? "" : 0));

var HeroRecipeForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Form */.l0,  true ? {
  target: "e1i0xmei0"
} : 0)( true ? {
  name: "1lws3ny",
  styles: "padding-top:48px;margin:0 auto"
} : 0);

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 237 modules
var Company = __webpack_require__(97079);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/Logos/Logos.tsx







var Logos_copy = {
  description: "Innovative healthcare and life sciences organizations build personalized experience that improve outcomes with Segment."
};

var Logos = function Logos() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextDescription, {
          variant: "pMedium",
          tag: "p",
          children: Logos_copy.description
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledColumnTrack, {
        overrides: {
          xs: 2,
          md: 2,
          lg: 4
        },
        center: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* AllerganLogo */.Rko, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* AmbossLogo */.car, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* ChopraLogo */.ub1, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* RitualLogo */.QVK, {})]
      })
    })]
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "elqf3ht2"
} : 0)("max-width:524px;", Section/* Wrapper */.im, "{gap:32px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{padding:72px 0 44px;}}" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "elqf3ht1"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-left:40px;padding-right:40px;}column-gap:24px;" + ( true ? "" : 0));

var CopyTextDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "elqf3ht0"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{text-align:center;}" + ( true ? "" : 0));

/* harmony default export */ var Logos_Logos = (Logos);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var components_Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/PropCard/index.ts + 6 modules
var PropCard = __webpack_require__(62456);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/HipaaCompliantBadge@2x.png
var HipaaCompliantBadge_2x = __webpack_require__(16526);
var HipaaCompliantBadge_2x_default = /*#__PURE__*/__webpack_require__.n(HipaaCompliantBadge_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/HipaaCompliantBadge.webp
/* harmony default export */ var HipaaCompliantBadge = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/HipaaCompliantBadge@2x.webp
var assets_HipaaCompliantBadge_2x = __webpack_require__(55017);
var assets_HipaaCompliantBadge_2x_default = /*#__PURE__*/__webpack_require__.n(assets_HipaaCompliantBadge_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27001Badge@2x.png
var Iso27001Badge_2x = __webpack_require__(28397);
var Iso27001Badge_2x_default = /*#__PURE__*/__webpack_require__.n(Iso27001Badge_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27001Badge.webp
/* harmony default export */ var Iso27001Badge = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27001Badge@2x.webp
/* harmony default export */ var assets_Iso27001Badge_2x = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27017Badge@2x.png
var Iso27017Badge_2x = __webpack_require__(33916);
var Iso27017Badge_2x_default = /*#__PURE__*/__webpack_require__.n(Iso27017Badge_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27017Badge.webp
/* harmony default export */ var Iso27017Badge = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27017Badge@2x.webp
/* harmony default export */ var assets_Iso27017Badge_2x = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27018Badge@2x.png
var Iso27018Badge_2x = __webpack_require__(41764);
var Iso27018Badge_2x_default = /*#__PURE__*/__webpack_require__.n(Iso27018Badge_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27018Badge.webp
/* harmony default export */ var Iso27018Badge = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/Iso27018Badge@2x.webp
/* harmony default export */ var assets_Iso27018Badge_2x = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/AicpaSocBadge@2x.png
var AicpaSocBadge_2x = __webpack_require__(84046);
var AicpaSocBadge_2x_default = /*#__PURE__*/__webpack_require__.n(AicpaSocBadge_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/AicpaSocBadge.webp
/* harmony default export */ var AicpaSocBadge = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/AicpaSocBadge@2x.webp
var assets_AicpaSocBadge_2x = __webpack_require__(33051);
var assets_AicpaSocBadge_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AicpaSocBadge_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/CsaBadge@2x.png
var CsaBadge_2x = __webpack_require__(86179);
var CsaBadge_2x_default = /*#__PURE__*/__webpack_require__.n(CsaBadge_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/CsaBadge.webp
/* harmony default export */ var CsaBadge = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/CsaBadge@2x.webp
/* harmony default export */ var assets_CsaBadge_2x = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/DataDrivenReport@2x.png
var DataDrivenReport_2x = __webpack_require__(2326);
var DataDrivenReport_2x_default = /*#__PURE__*/__webpack_require__.n(DataDrivenReport_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/DataDrivenReport.webp
var DataDrivenReport = __webpack_require__(37326);
var DataDrivenReport_default = /*#__PURE__*/__webpack_require__.n(DataDrivenReport);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/assets/DataDrivenReport@2x.webp
var assets_DataDrivenReport_2x = __webpack_require__(81152);
var assets_DataDrivenReport_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DataDrivenReport_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/IndustryLeadingSecurity/IndustryLeadingSecurity.tsx



function IndustryLeadingSecurity_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



































var IndustryLeadingSecurity_copy = {
  overline: "Security Highlight",
  heading: "Industry-leading Security & Compliance",
  description: "Twilio Segment is HIPAA-eligible and able to receive, maintain, and transmit PHI on behalf of our customers in the healthcare industry. Segment is able to sign BAAs for managing PHI, or PII that should be treated as PHI.",
  learnMore: "Learn more about how <a href=\"https://twil.io/architecting-for-hipaa/\">to architect compliantly with Segment</a>."
};
var IndustryLeadingSecurity_link = {
  text: "Explore the Privacy Portal",
  url: "/product/privacy-portal/"
};
var card = {
  heading: "Data-Driven Strategies for Growth: A Guide for Healthcare Businesses",
  description: "In this guide we cover why healthcare leaders should consider a customer data platform (CDP) to create better patient interactions across the care journey.",
  link: {
    text: "Access the guide",
    url: "https://learn.segment.com/cdp-for-healthcare/"
  }
};

var IndustryLeadingSecurity = function IndustryLeadingSecurity() {
  var pageConfig = (0,page/* usePageConfig */.Gm)(); // Mobile breakpoints

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IndustryLeadingSecurity_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FirstSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyText, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: IndustryLeadingSecurity_copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: IndustryLeadingSecurity_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: IndustryLeadingSecurity_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: (0,getAbsoluteUrl/* default */.Z)(IndustryLeadingSecurity_link.url, pageConfig),
            children: IndustryLeadingSecurity_link.text
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SecondSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IndustryLeadingSecurity_StyledColumnTrack, {
          columns: 1,
          overrides: {
            xs: 2,
            lg: 3
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "ISO 27001",
            images: {
              webp: Iso27001Badge,
              webp2x: assets_Iso27001Badge_2x,
              png2x: (Iso27001Badge_2x_default())
            },
            size: [120, 140]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "ISO 27017",
            images: {
              webp: Iso27017Badge,
              webp2x: assets_Iso27017Badge_2x,
              png2x: (Iso27017Badge_2x_default())
            },
            size: [120, 140]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "ISO 27018",
            images: {
              webp: Iso27018Badge,
              webp2x: assets_Iso27018Badge_2x,
              png2x: (Iso27018Badge_2x_default())
            },
            size: [120, 140]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "Cloud Security Alliance",
            images: {
              webp: CsaBadge,
              webp2x: assets_CsaBadge_2x,
              png2x: (CsaBadge_2x_default())
            },
            size: [180, 64]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "AICPA SOC",
            images: {
              webp: AicpaSocBadge,
              webp2x: (assets_AicpaSocBadge_2x_default()),
              png2x: (AicpaSocBadge_2x_default())
            },
            size: [96, 96]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "HIPAA Compliant",
            images: {
              webp: HipaaCompliantBadge,
              webp2x: (assets_HipaaCompliantBadge_2x_default()),
              png2x: (HipaaCompliantBadge_2x_default())
            },
            size: [180, 96]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndustryLeadingSecurity_CopyTextDescription, {
          tag: "div",
          dangerouslySetInnerHTML: {
            __html: sanitize_html_default()(IndustryLeadingSecurity_copy.learnMore, {
              allowedTags: ["a"]
            })
          }
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThirdSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPropCardBase, {
        reverse: isSmallResolution,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PropCard/* Copy */.CK, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Title */.Dx, {
            children: card.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Text */.xv, {
            children: card.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            href: card.link.url,
            size: "large",
            tag: "a",
            variant: "filled",
            children: card.link.text
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Img */.Ei, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: card.heading,
            images: {
              webp: (DataDrivenReport_default()),
              webp2x: (assets_DataDrivenReport_2x_default()),
              png2x: (DataDrivenReport_2x_default())
            },
            size: [312, 288]
          })
        })]
      })
    })]
  });
};

var Image = function Image(_ref) {
  var images = _ref.images,
      alt = _ref.alt,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? [179, 120] : _ref$size;

  var _size = (0,slicedToArray/* default */.Z)(size, 2),
      w = _size[0],
      h = _size[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat(images.webp, ", ").concat(images.webp2x, " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
        width: w,
        height: h,
        src: images.png2x,
        alt: alt,
        loading: "lazy"
      })]
    })
  });
};

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evc4dw18"
} : 0)( true ? {
  name: "nohnyt",
  styles: "display:flex;align-items:center;flex-direction:column;justify-content:center"
} : 0);

var IndustryLeadingSecurity_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evc4dw17"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{max-width:720px;margin:auto;}" + ( true ? "" : 0));

var StyledPropCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(PropCard/* default */.ZP,  true ? {
  target: "evc4dw16"
} : 0)("max-width:800px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{padding:56px 0 56px 56px;}" + ( true ? "" : 0));

var FirstSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "evc4dw15"
} : 0)(Section/* Wrapper */.im, "{row-gap:0;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("md");
}, "{padding-left:0;padding-right:0;}}" + ( true ? "" : 0));

var SecondSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "evc4dw14"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:40px;}" + ( true ? "" : 0));

var ThirdSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "evc4dw13"
} : 0)(Section/* Wrapper */.im, "{", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:0;padding-bottom:0;}}" + ( true ? "" : 0));

var StyledCopyText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "evc4dw12"
} : 0)(function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.down("md");
}, "{text-align:left;}" + ( true ? "" : 0));

var IndustryLeadingSecurity_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "evc4dw11"
} : 0)( true ? {
  name: "11k4lvr",
  styles: "row-gap:40px;column-gap:40px;max-width:616px;margin:0 auto"
} : 0);

var IndustryLeadingSecurity_CopyTextDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "evc4dw10"
} : 0)( true ? {
  name: "1ncwmwg",
  styles: "padding-top:74px;text-align:center"
} : 0);

/* harmony default export */ var IndustryLeadingSecurity_IndustryLeadingSecurity = (IndustryLeadingSecurity);
// EXTERNAL MODULE: ../../libs/templates/TestimonialSlider/index.ts + 11 modules
var TestimonialSlider = __webpack_require__(88302);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 229 modules
var CompanyMono = __webpack_require__(71385);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/Testimonials/data.tsx





var testimonialData = function testimonialData() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return [{
    company: "allergan",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AllerganMonoLogo */.ubl, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* AllerganLogo */.Rko, {}),
    logoName: "Allergan"
  }, {
    company: "amboss",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AmbossMonoLogo */.D9K, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* AmbossLogo */.car, {}),
    logoName: "Amboss"
  }, {
    company: "chopra",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ChopraMonoLogo */.aIE, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* ChopraLogo */.ub1, {}),
    logoName: "Chopra"
  }, {
    company: "ritual",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RitualMonoLogo */.qWP, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* RitualLogo */.QVK, {}),
    logoName: "Ritual"
  }];
};


;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/Testimonials/Testimonials.tsx






var Testimonials = function Testimonials() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials_StyledSection, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider["default"], {
      title: false,
      data: testimonialData,
      innerStyles: false
    })
  });
};

var Testimonials_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1chsyvb0"
} : 0)("max-width:1260px;overflow-x:inherit;", Section/* Wrapper */.im, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:120px;padding-bottom:120px;}}" + ( true ? "" : 0));

/* harmony default export */ var Testimonials_Testimonials = (Testimonials);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/MakeDataDrivenDecisions/assets/MakeDataDrivenDecisions@2x.png
var MakeDataDrivenDecisions_2x = __webpack_require__(8540);
var MakeDataDrivenDecisions_2x_default = /*#__PURE__*/__webpack_require__.n(MakeDataDrivenDecisions_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/MakeDataDrivenDecisions/assets/MakeDataDrivenDecisions.webp
var MakeDataDrivenDecisions = __webpack_require__(65814);
var MakeDataDrivenDecisions_default = /*#__PURE__*/__webpack_require__.n(MakeDataDrivenDecisions);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/MakeDataDrivenDecisions/assets/MakeDataDrivenDecisions@2x.webp
var assets_MakeDataDrivenDecisions_2x = __webpack_require__(93687);
var assets_MakeDataDrivenDecisions_2x_default = /*#__PURE__*/__webpack_require__.n(assets_MakeDataDrivenDecisions_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/MakeDataDrivenDecisions/MakeDataDrivenDecisionsImage.tsx








var MakeDataDrivenDecisionsImage = function MakeDataDrivenDecisionsImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 1,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((MakeDataDrivenDecisions_default()), ", ").concat((assets_MakeDataDrivenDecisions_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
        width: "559",
        height: "539",
        src: (MakeDataDrivenDecisions_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var MakeDataDrivenDecisions_MakeDataDrivenDecisionsImage = (MakeDataDrivenDecisionsImage);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/MakeDataDrivenDecisions/MakeDataDrivenDecisions.tsx


function MakeDataDrivenDecisions_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var MakeDataDrivenDecisions_copy = {
  heading: "Make data driven decisions that can transform care management"
};
var MakeDataDrivenDecisions_link = {
  text: "Explore Journeys",
  url: "/product/twilio-engage/"
};
var feature = [{
  head: "Build",
  description: "Create personalized patient experiences with timely and impactful interactions across the care journey."
}, {
  head: "Engage",
  description: "Leverage real-time customer Profiles to build Audiences based on patient or member data, and engage them on their preferred channel."
}, {
  head: "Transform",
  description: "Give relevant context to every team in your organization, with data they can trust, and start a continuous conversation with customers."
}];

var MakeDataDrivenDecisions_MakeDataDrivenDecisions = function MakeDataDrivenDecisions() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeDataDrivenDecisions_MakeDataDrivenDecisionsImage, {
        alt: "Illustration: ".concat(MakeDataDrivenDecisions_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: MakeDataDrivenDecisions_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            gap: "small",
            children: feature.map(function (feature) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    children: feature.head
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Text */.xv, {
                    children: [feature.description, " "]
                  })]
                })
              }, feature.head);
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(MakeDataDrivenDecisions_link.url, pageConfig),
          children: MakeDataDrivenDecisions_link.text
        })]
      })
    })]
  });
};

/* harmony default export */ var components_MakeDataDrivenDecisions_MakeDataDrivenDecisions = (MakeDataDrivenDecisions_MakeDataDrivenDecisions);

var SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "er1urc83"
} : 0)( true ? {
  name: "inj3dq",
  styles: "margin:auto 0"
} : 0);

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "er1urc82"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "er1urc81"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;align-self:center;}" + ( true ? "" : 0));

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "er1urc80"
} : 0)( true ? {
  name: "j3we6u",
  styles: "padding-top:40px"
} : 0);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/DefineDetectValidate/assets/DefineDetectValidate@2x.png
var DefineDetectValidate_2x = __webpack_require__(99688);
var DefineDetectValidate_2x_default = /*#__PURE__*/__webpack_require__.n(DefineDetectValidate_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/DefineDetectValidate/assets/DefineDetectValidate.webp
var DefineDetectValidate = __webpack_require__(44098);
var DefineDetectValidate_default = /*#__PURE__*/__webpack_require__.n(DefineDetectValidate);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/DefineDetectValidate/assets/DefineDetectValidate@2x.webp
var assets_DefineDetectValidate_2x = __webpack_require__(79423);
var assets_DefineDetectValidate_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DefineDetectValidate_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/DefineDetectValidate/DefineDetectValidateImage.tsx








var DefineDetectValidateImage = function DefineDetectValidateImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 1,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((DefineDetectValidate_default()), ", ").concat((assets_DefineDetectValidate_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
        width: "560",
        height: "534",
        src: (DefineDetectValidate_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var DefineDetectValidate_DefineDetectValidateImage = (DefineDetectValidateImage);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/DefineDetectValidate/DefineDetectValidate.tsx


function DefineDetectValidate_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var DefineDetectValidate_copy = {
  heading: "Define, detect, and validate data quality violations and enforce privacy controls."
};
var DefineDetectValidate_feature = [{
  head: "Trust",
  description: "Automate and scale data quality best practices with Tracking Plans to power your tools with clean, reliable data. "
}, {
  head: "Empower",
  description: "Align your teams and tools with secure and consistent patient, member or clinician data."
}, {
  head: "Protect",
  description: "Simplify compliance with automated data governance and real-time sensitive data, including PHI and PII, screening."
}];
var DefineDetectValidate_link = {
  text: "Explore Protocols",
  url: "/product/protocols/"
};

var DefineDetectValidate_DefineDetectValidate = function DefineDetectValidate() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DefineDetectValidate_StyledSectionBase, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefineDetectValidate_SectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefineDetectValidate_DefineDetectValidateImage, {
        alt: "Illustration: ".concat(DefineDetectValidate_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefineDetectValidate_StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: DefineDetectValidate_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefineDetectValidate_ColumnTrackWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            gap: "small",
            children: DefineDetectValidate_feature.map(function (feature) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    children: feature.head
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Text */.xv, {
                    children: [feature.description, " "]
                  })]
                })
              }, feature.head);
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(DefineDetectValidate_link.url, pageConfig),
          children: DefineDetectValidate_link.text
        })]
      })
    })]
  });
};

/* harmony default export */ var components_DefineDetectValidate_DefineDetectValidate = (DefineDetectValidate_DefineDetectValidate);

var DefineDetectValidate_SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1w964fw3"
} : 0)( true ? {
  name: "inj3dq",
  styles: "margin:auto 0"
} : 0);

var DefineDetectValidate_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1w964fw2"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var DefineDetectValidate_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1w964fw1"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;align-self:center;}" + ( true ? "" : 0));

var DefineDetectValidate_ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w964fw0"
} : 0)( true ? {
  name: "j3we6u",
  styles: "padding-top:40px"
} : 0);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/UncoverKeyMoments/assets/UncoverKeyMoments@2x.png
var UncoverKeyMoments_2x = __webpack_require__(5987);
var UncoverKeyMoments_2x_default = /*#__PURE__*/__webpack_require__.n(UncoverKeyMoments_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/UncoverKeyMoments/assets/UncoverKeyMoments.webp
var UncoverKeyMoments = __webpack_require__(7901);
var UncoverKeyMoments_default = /*#__PURE__*/__webpack_require__.n(UncoverKeyMoments);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/UncoverKeyMoments/assets/UncoverKeyMoments@2x.webp
var assets_UncoverKeyMoments_2x = __webpack_require__(64300);
var assets_UncoverKeyMoments_2x_default = /*#__PURE__*/__webpack_require__.n(assets_UncoverKeyMoments_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/UncoverKeyMoments/UncoverKeyMomentsImage.tsx








var UncoverKeyMomentsImage = function UncoverKeyMomentsImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 1,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((UncoverKeyMoments_default()), ", ").concat((assets_UncoverKeyMoments_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
        width: "589",
        height: "420",
        src: (UncoverKeyMoments_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var UncoverKeyMoments_UncoverKeyMomentsImage = (UncoverKeyMomentsImage);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/UncoverKeyMoments/UncoverKeyMoments.tsx


function UncoverKeyMoments_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var UncoverKeyMoments_copy = {
  heading: "Uncover key moments in the care journey that impact retention and health outcomes"
};
var UncoverKeyMoments_link = {
  text: "Explore Connections",
  url: "/product/connections/"
};
var UncoverKeyMoments_feature = [{
  head: "Collect",
  description: "See the complete view of your patient or member by unifying data across web, mobile web, apps, support and offline interactions."
}, {
  head: "Understand",
  description: "Identify traits of your patients and members and uncover key triggers along the care journey that impact engagement, retention and health outcomes."
}, {
  head: "Centralize",
  description: "Centralize and scale access to high-quality, secure data and deliver it to the tools and internal teams that need it."
}];

var UncoverKeyMoments_UncoverKeyMoments = function UncoverKeyMoments() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UncoverKeyMoments_StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UncoverKeyMoments_SectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UncoverKeyMoments_UncoverKeyMomentsImage, {
        alt: "Illustration: ".concat(UncoverKeyMoments_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UncoverKeyMoments_StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: UncoverKeyMoments_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UncoverKeyMoments_ColumnTrackWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            gap: "small",
            children: UncoverKeyMoments_feature.map(function (feature) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    children: feature.head
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Text */.xv, {
                    children: [feature.description, " "]
                  })]
                })
              }, feature.head);
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(UncoverKeyMoments_link.url, pageConfig),
          children: UncoverKeyMoments_link.text
        })]
      })
    })]
  });
};

/* harmony default export */ var components_UncoverKeyMoments_UncoverKeyMoments = (UncoverKeyMoments_UncoverKeyMoments);

var UncoverKeyMoments_SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "ebqh41w3"
} : 0)( true ? {
  name: "inj3dq",
  styles: "margin:auto 0"
} : 0);

var UncoverKeyMoments_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ebqh41w2"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var UncoverKeyMoments_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ebqh41w1"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;align-self:center;}" + ( true ? "" : 0));

var UncoverKeyMoments_ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebqh41w0"
} : 0)( true ? {
  name: "j3we6u",
  styles: "padding-top:40px"
} : 0);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/UseSegment/assets/UseSegment@2x.png
var UseSegment_2x = __webpack_require__(39856);
var UseSegment_2x_default = /*#__PURE__*/__webpack_require__.n(UseSegment_2x);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/UseSegment/assets/UseSegment.webp
var UseSegment = __webpack_require__(45998);
var UseSegment_default = /*#__PURE__*/__webpack_require__.n(UseSegment);
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/components/UseSegment/assets/UseSegment@2x.webp
var assets_UseSegment_2x = __webpack_require__(35857);
var assets_UseSegment_2x_default = /*#__PURE__*/__webpack_require__.n(assets_UseSegment_2x);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/UseSegment/UseSegmentImage.tsx








var UseSegmentImage = function UseSegmentImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((UseSegment_default()), ", ").concat((assets_UseSegment_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
        width: "616",
        height: "488",
        src: (UseSegment_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var UseSegment_UseSegmentImage = (UseSegmentImage);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/components/UseSegment/UseSegment.tsx


function UseSegment_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var UseSegment_copy = {
  heading: "Use Segment to integrate with internal systems and best-in-class tools",
  description: "See the complete view of your patient or member by unifying data across web, mobile web, apps, support and offline interactions."
};

var UseSegment_UseSegment = function UseSegment() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UseSegment_StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseSegment_SectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseSegment_UseSegmentImage, {
        alt: "Illustration: ".concat(UseSegment_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseSegment_StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: UseSegment_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: UseSegment_copy.description
        })]
      })
    })]
  });
};

/* harmony default export */ var components_UseSegment_UseSegment = (UseSegment_UseSegment);

var UseSegment_SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e7nxpkp2"
} : 0)( true ? {
  name: "inj3dq",
  styles: "margin:auto 0"
} : 0);

var UseSegment_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e7nxpkp1"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var UseSegment_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e7nxpkp0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;align-self:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/views/Industry/HealthcarePage/assets/OgHealthcare.png
var OgHealthcare = __webpack_require__(67440);
var OgHealthcare_default = /*#__PURE__*/__webpack_require__.n(OgHealthcare);
;// CONCATENATED MODULE: ./src/views/Industry/HealthcarePage/Healthcare.tsx



















var HealthcareView = function HealthcareView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Industries | Healthcare & Life Sciences | Twilio Segment",
      pageDescription: "Unlock patient and member data with Twilio Segment for Healthcare. Engage patients with personalized experiences designed to retain and improve health outcomes\u2014all while remaining HIPAA compliant.",
      pageOG: (OgHealthcare_default()),
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logos_Logos, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MakeDataDrivenDecisions_MakeDataDrivenDecisions, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DefineDetectValidate_DefineDetectValidate, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_UncoverKeyMoments_UncoverKeyMoments, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndustryLeadingSecurity_IndustryLeadingSecurity, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_UseSegment_UseSegment, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials_Testimonials, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "ec6ytvv0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var HealthcarePage_Healthcare = (HealthcareView);
;// CONCATENATED MODULE: ./src/pages/industry/healthcare.tsx



var Healthcare = function Healthcare() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HealthcarePage_Healthcare, {});
};

/* harmony default export */ var healthcare = (Healthcare);

/***/ }),

/***/ 96856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useLocation_useLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/location.ts



var fetchLocation = function fetchLocation(client, signal) {
  return client.get("/location/", {
    signal: signal,
    headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
  });
};

var fetchLocationCode = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, signal) {
    var code;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/location/countryCode/", {
              signal: signal,
              headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
            });

          case 2:
            code = _context.sent;
            return _context.abrupt("return", code.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLocationCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/useLocation.ts





/**
 * A hook that provides the country code of the user's location.
 * @returns The country code of the user's location.
 */

var useLocation = function useLocation() {
  var _useState = (0,react.useState)(""),
      code = _useState[0],
      setCode = _useState[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocationCode((0,client/* createClient */.e)(), signal);

            case 3:
              response = _context.sent;
              setCode(response.toLowerCase());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setCode("us");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react.useEffect)(function () {
    var controller = new AbortController();
    fetchData(controller.signal);
    return function () {
      controller.abort();
    };
  }, [fetchData]);
  return code;
};

/* harmony default export */ var useLocation_useLocation = (useLocation);
;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/index.ts


/***/ }),

/***/ 805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DemoProvider; },
/* harmony export */   "d": function() { return /* binding */ DemoContext; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DemoContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  completedFormData: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCompletedFormData: function setCompletedFormData() {}
});
var DemoProvider = function DemoProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    completedFormData: undefined,
    setCompletedFormData: function setCompletedFormData(value) {
      return setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          completedFormData: value
        });
      });
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DemoContext.Provider, {
    value: state,
    children: children
  });
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 77840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FormSubmitMessage; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/data.tsx
var data = {
  success: {
    demo: {
      description: "Thank you for submitting your request for a demo! Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment."
    }
  },
  error: {
    demo: {
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq3"
} : 0)("padding:32px;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq2"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq1"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq0"
} : 0)( true ? {
  name: "7ut0hf",
  styles: "margin:0;margin-bottom:16px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx


var _excluded = ["form", "status", "heading", "description", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseFormSubmitMessage = function BaseFormSubmitMessage(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens.wrapper), rest), {}, {
      children: [heading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      })]
    }))
  });
};

var FormSubmitMessage = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitMessage, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  }
});
/* harmony default export */ var FormSubmitMessage_FormSubmitMessage = ((/* unused pure expression or super */ null && (FormSubmitMessage)));

/***/ }),

/***/ 92472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DemoForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/lodash/isNil.js
var isNil = __webpack_require__(1842);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 23 modules
var FormFields = __webpack_require__(20444);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/api/utils/useLocation/index.ts + 2 modules
var useLocation = __webpack_require__(96856);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
// EXTERNAL MODULE: ../../libs/utils/regexes/website.ts
var website = __webpack_require__(10137);
;// CONCATENATED MODULE: ../../libs/utils/regexes/personalEmail.ts
var personalEmailRegex = /@(gmail|yahoo|hotmail|me|icloud|personal)\.com$/g;
/* harmony default export */ var personalEmail = (personalEmailRegex);
;// CONCATENATED MODULE: ../../libs/utils/regexes/forbiddenEmail.ts
var customDomainList = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@aol.com", "@hotmail.co.uk", "@hotmail.fr", "@msn.com", "@yahoo.fr", "@wanadoo.fr", "@orange.fr", "@comcast.net", "@yahoo.co.uk", "@yahoo.com.br", "@yahoo.co.in", "@live.com", "@rediffmail.com", "@free.fr", "@gmx.de", "@web.de", "@yandex.ru", "@ymail.com", "@libero.it", "@outlook.com", "@uol.com.br", "@bol.com.br", "@mail.ru", "@cox.net", "@hotmail.it", "@sbcglobal.net", "@sfr.fr", "@live.fr", "@verizon.net", "@live.co.uk", "@googlemail.com", "@yahoo.es", "@ig.com.br", "@live.nl", "@bigpond.com", "@terra.com.br", "@yahoo.it", "@neuf.fr", "@yahoo.de", "@alice.it", "@rocketmail.com", "@att.net", "@laposte.net", "@facebook.com", "@bellsouth.net", "@yahoo.in", "@hotmail.es", "@charter.net", "@yahoo.ca", "@yahoo.com.au", "@rambler.ru", "@hotmail.de", "@tiscali.it", "@shaw.ca", "@yahoo.co.jp", "@sky.com", "@earthlink.net", "@optonline.net", "@freenet.de", "@t-online.de", "@aliceadsl.fr", "@virgilio.it", "@home.nl", "@qq.com", "@telenet.be", "@me.com", "@yahoo.com.ar", "@tiscali.co.uk", "@yahoo.com.mx", "@voila.fr", "@gmx.net", "@mail.com", "@planet.nl", "@tin.it", "@live.it", "@ntlworld.com", "@arcor.de", "@yahoo.co.id", "@frontiernet.net", "@hetnet.nl", "@live.com.au", "@yahoo.com.sg", "@zonnet.nl", "@club-internet.fr", "@juno.com", "@optusnet.com.au", "@blueyonder.co.uk", "@bluewin.ch", "@skynet.be", "@sympatico.ca", "@windstream.net", "@mac.com", "@centurytel.net", "@chello.nl", "@live.ca", "@aim.com", "@bigpond.net.au", "@email.com", "@gmail", "@yahoo", "@hotmail", "@outlook", "@protonmail", "@gwk.com", "@free.", "@tutanota", "@gmx", "@mail2world", "@icloud", "@segment.com", "@.om", "@163.com", "@qq", "@gmai.com", "@yaoo.com", "@company.com", "@gail.com", "@abc.com", "@domain.com", "@gma.com", "@gnail.com", "@li.com", "@yah.com", "@5euros.com", "@business.com", "@emil.com", "@gaylord.info", "@gimal.com", "@gml.com", "@info.com", "@mailinator.com", "@w.com", "@yhoo.com", "@yo.com", "@0546876.com", "@10.com", "@101.gmail.com", "@11.com", "@12356gmail.com", "@123yahoo.com", "@175gmali.com", "@1servicesteamfrazier.com", "@2gmail.com", "@2ncad.com", "@365gmial.com", "@37.com", "@5024gmail.com", "@70gmail.com", "@72gmail.co.com", "@81gmail.com", "@8543g.mail.com", "@9085.gmail.com", "@9784.com", "@asdf.com", "@asdfas222334.com", "@asdsad.com", "@fuckyou.com", "@g.com", "@g.email", "@gamill.com", "@gimel.com", "@gl.com", "@gmaiil.com", "@gmaik.com", "@gmail-elif.com", "@gmail.com.pk", "@gmail.com120194", "@gmail.com4", "@gmaile.com", "@gmaill.com", "@gmaiol.com", "@gmaqil.com", "@gmaul.com", "@gmeel.come", "@gmil.comraj", "@gmsil.com", "@gmw.ere", "@gnail.con", "@haha.com", "@hahaha.com", "@il.co", "@il.com", "@test.cc", "@us.army.mil", "@ya.com", "@yaahoo.com", "@yahoo.coin", "@yho.com", "@yohoo.com", "@.aim", "@zoho", "@protonmail.com", "@mailinator", "@boutique1.com", "@bugfoo.com", "@duiter.com", "@fectode.com", "@gmial.com", "@jewelry.com", "@jims.net", "@jthoven.com", "@lolcorporate.com", "@naver.com", "@restaurant.com", "@stayclearbeauty.com", "@tem.com.my", "@thegymgroup.com", "@Marco.com"]; // Escape the dots in the domains, as they have a special meaning in regex

var escapedDomains = customDomainList.map(function (domain) {
  return domain.replace(/\./g, "\\.");
}); // Create the regex pattern using negative lookahead
// eslint-disable-next-line @typescript-eslint/naming-convention

var regexPattern = "^(?!.*(".concat(escapedDomains.join("|"), ")).*$");
var forbiddenEmailRegex = new RegExp(regexPattern, "i"); // Use the 'i' flag for case-insensitive matching

/* harmony default export */ var forbiddenEmail = (forbiddenEmailRegex);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.views.tsx

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc2"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc1"
} : 0)( true ? "" : 0);
var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.tsx



var _excluded = ["appearance", "className", "before", "after", "isProgressive", "isLeadEnrichmentFormEnabled", "overrideConsent", "customFormIdentifier", "customTrackingType", "successMessageAppearance", "onEmailCompleted", "buttonText", "customDisclaimer", "driftCampaignId", "isDemoRequest", "successMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






























var MOBILE_OFFSET = -150;
var DESKTOP_OFFSET = -350;
var FORM_ID = "demo-form"; // Set up demo form props since we define some of these props here in the template

var DemoForm = function DemoForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$isProgressive = _ref.isProgressive,
      isProgressive = _ref$isProgressive === void 0 ? false : _ref$isProgressive,
      _ref$isLeadEnrichment = _ref.isLeadEnrichmentFormEnabled,
      isLeadEnrichmentFormEnabled = _ref$isLeadEnrichment === void 0 ? true : _ref$isLeadEnrichment,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      successMessageAppearance = _ref.successMessageAppearance,
      onEmailCompleted = _ref.onEmailCompleted,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Get a demo" : _ref$buttonText,
      customDisclaimer = _ref.customDisclaimer,
      driftCampaignId = _ref.driftCampaignId,
      _ref$isDemoRequest = _ref.isDemoRequest,
      isDemoRequest = _ref$isDemoRequest === void 0 ? false : _ref$isDemoRequest,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var countryCode = (0,useLocation/* default */.Z)(); // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality

  var _useState = (0,react.useState)(false),
      emailCompleted = _useState[0],
      setEmailCompleted = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      intPhoneErrorCode = _useState2[0],
      setIntPhoneErrorCode = _useState2[1];

  var _useState3 = (0,react.useState)(),
      submittedEmail = _useState3[0],
      setSubmittedEmail = _useState3[1];
  /* eslint-disable camelcase */


  var schema = (0,react.useMemo)(function () {
    var _z$object;

    return lib/* object */.Ry((_z$object = {
      email: lib/* string */.Z_({
        required_error: FormFields/* companyEmailMessages.required */.BN.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(email/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      })
      /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
      .regex(sharedEmail/* default */.C, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(isDemoRequest ? forbiddenEmail : /.+/, {
        message: FormFields/* companyEmailMessages.forbiddenEmail */.BN.forbiddenEmail
      }),
      name: lib/* string */.Z_({
        required_error: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }).regex(lastName/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      phone: lib/* string */.Z_({
        invalid_type_error: FormFields/* phoneNumberMessages.invalid */.NJ.invalid
      }).min(1, FormFields/* phoneNumberMessages.required */.NJ.required).refine(function () {
        return intPhoneErrorCode === undefined;
      }, {
        message: (0,FormFields/* getPhoneErrorMessage */.AP)(intPhoneErrorCode)
      })
    }, (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_VALID_FIELD */.tj, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_ERRORS_FIELD */.q5, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_CALLING_COUNTRY_CODE */.iZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_COUNTRY_CODE */.$l, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NUMBER */.SZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NATIONAL_FORMAT */.UN, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, "company", lib/* string */.Z_({
      required_error: FormFields/* companyNameMessages.required */.qx.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyNameMessages.invalid */.qx.invalid
    })), (0,defineProperty/* default */.Z)(_z$object, "companyWebsite", lib/* string */.Z_({
      required_error: FormFields/* companyWebsiteMessages.required */.e4.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyWebsiteMessages.invalid */.e4.invalid
    }).regex(website/* default */.Z, {
      message: FormFields/* companyWebsiteMessages.invalid */.e4.invalid
    })), _z$object)).partial({
      companyWebsite: true
    });
  }, [intPhoneErrorCode]);
  /* eslint-enable camelcase */

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  }); // Watch for personal email

  var watchedEmail = methods === null || methods === void 0 ? void 0 : methods.watch("email", "");
  var isPersonalEmail = !isNil_default()(watchedEmail === null || watchedEmail === void 0 ? void 0 : watchedEmail.match(personalEmail)); // If this is the progressive version of the form, set up email watching
  // Otherwise just always return true

  var showProgressiveFields = isProgressive ? Boolean(watchedEmail || emailCompleted) : true; // Mobile breakpoints

  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  (0,react.useEffect)(function () {
    if (watchedEmail) {
      setEmailCompleted(true);
      if (onEmailCompleted) onEmailCompleted();
    }
  }, [watchedEmail]);
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo-request"),
    buttonText: "Create your free workspace"
  };

  var collectDriftFormData = function collectDriftFormData(formData) {
    var unTypedWindow = window;

    if (unTypedWindow.drift) {
      unTypedWindow.drift.api.collectFormData(_objectSpread(_objectSpread({}, formData), {}, {
        firstName: formData.name.split(" ")[0],
        lastName: formData.name.split(" ").slice(1).join(" ")
      }), {
        campaignId: driftCampaignId
      });
    }
  };

  (0,react.useEffect)(function () {
    if (methods.getValues("phone")) {
      methods.trigger("phone");
    }
  }, [intPhoneErrorCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: isLeadEnrichmentFormEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message"
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "error",
          "data-hook": "demo-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: function onSubmit(data) {
          setSubmittedEmail(data.email);
          (0,helpers/* createDemoLead */.Ii)(data);

          if (driftCampaignId) {
            collectDriftFormData(data);
          }

          if (isSmallResolution && showProgressiveFields) {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, MOBILE_OFFSET, false);
          } else {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, DESKTOP_OFFSET, false);
          }
        },
        onFailure: helpers/* trackValidationErrorDemoForm */.nR,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onBlur: helpers/* trackValidationErrorDemoForm */.nR
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PhoneNumberField */.g8, {
            countryCode: countryCode,
            onValidate: setIntPhoneErrorCode,
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyNameField */.wA, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), isPersonalEmail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyWebsiteField */.Zf, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          })]
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: buttonText
          })
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer,
            appearance: successMessageAppearance
          })
        })]
      }))
    }), isLeadEnrichmentFormEnabled && methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
      before: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, {
        status: "success",
        form: "demo"
      }),
      email: submittedEmail,
      successMessage: successMessage
    })]
  });
};
/* harmony default export */ var DemoForm_DemoForm = ((/* unused pure expression or super */ null && (DemoForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/index.ts


/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProgressiveProfileForm; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 23 modules
var FormFields = __webpack_require__(20444);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/HiddenEmail.tsx


var _excluded = ["type", "name", "id", "className", "dataHook", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * Email hidden input for demo forms
 */

var HiddenEmailField = function HiddenEmailField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
    "data-testid": "email",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx



var ProgressiveProfileForm_excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "successMessageAppearance", "email", "successMessage"];


function ProgressiveProfileForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProgressiveProfileForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ProgressiveProfileForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProgressiveProfileForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
























var BUTTON_TEXT = "Let's get started";
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  jobTitle: lib/* string */.Z_({
    required_error: JobTitle/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: JobTitle/* jobTitleMessages.invalid */.cY.invalid
  }),
  companySize: lib/* string */.Z_({
    required_error: CompanySize/* companySizeMessages.required */.CF.required
  }),
  monthlyTraffic: lib/* string */.Z_({
    required_error: MonthlyTraffic/* monthlyTrafficMessages.required */.dn.required
  }),
  timeline: lib/* string */.Z_({
    required_error: Timeline/* timelineMessages.required */.Cb.required
  }),
  email: lib/* string */.Z_().optional()
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var ProgressiveProfileForm = function ProgressiveProfileForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      successMessageAppearance = _ref.successMessageAppearance,
      email = _ref.email,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProgressiveProfileForm_excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("progressive-profile-form", -200);

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      setCompletedFormData = _useContext.setCompletedFormData; // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality


  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo-request"),
    buttonText: "Create your free workspace"
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "progressive-profile-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, ProgressiveProfileForm_objectSpread(ProgressiveProfileForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message",
          onButtonClick: function onButtonClick() {
            (0,helpers/* trackButtonClick */.kO)({
              buttonText: successMessage.buttonText,
              buttonId: "Workspace signup",
              targetUrl: successMessage.buttonUrl
            });
          }
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          status: "error"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setCompletedFormData(data);
                    _context.next = 3;
                    return (0,helpers/* trackProgressiveProfileForm */.NX)(data);

                  case 3:
                    scrollTo();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onFailure: helpers/* trackValidationErrorProgressiveProfileForm */.An,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobTitle/* JobTitleField */.kL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySize/* CompanySizeSelectField */.BQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MonthlyTraffic/* MonthlyTrafficSelectField */.VW, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Timeline/* TimelineSelectField */.fz, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), email && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenEmailField, {
          value: email
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: BUTTON_TEXT
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};
/* harmony default export */ var ProgressiveProfileForm_ProgressiveProfileForm = ((/* unused pure expression or super */ null && (ProgressiveProfileForm)));

/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 38720:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/healthcare",
      function () {
        return __webpack_require__(66211);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67440:
/***/ (function(module) {

module.exports = "/_next/static/images/OgHealthcare-661dd853b2e4d0981c8b6046c92c64bd.png";

/***/ }),

/***/ 99688:
/***/ (function(module) {

module.exports = "/_next/static/images/DefineDetectValidate@2x-de0bd047e47be92b4bf3523bbeab954e.png";

/***/ }),

/***/ 33420:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-fbdd45a978d47def60586d5f478c73a6.png";

/***/ }),

/***/ 68068:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroMobile@2x-27a7774ab3b71d7c3faf68eb7ffa11ab.png";

/***/ }),

/***/ 84046:
/***/ (function(module) {

module.exports = "/_next/static/images/AicpaSocBadge@2x-9403a05805728171f8b15a15eca31aba.png";

/***/ }),

/***/ 86179:
/***/ (function(module) {

module.exports = "/_next/static/images/CsaBadge@2x-65ea75625e379d9b9eb80579d7957adb.png";

/***/ }),

/***/ 2326:
/***/ (function(module) {

module.exports = "/_next/static/images/DataDrivenReport@2x-0ce63e100baee6fe98cbfc8b73d2a931.png";

/***/ }),

/***/ 16526:
/***/ (function(module) {

module.exports = "/_next/static/images/HipaaCompliantBadge@2x-0367edd9c30305e30b6e64fe1581f0ff.png";

/***/ }),

/***/ 28397:
/***/ (function(module) {

module.exports = "/_next/static/images/Iso27001Badge@2x-25f4f13de768df2d7d948d485acb390f.png";

/***/ }),

/***/ 33916:
/***/ (function(module) {

module.exports = "/_next/static/images/Iso27017Badge@2x-f6fb4bc962b4b9592d3c371664814e00.png";

/***/ }),

/***/ 41764:
/***/ (function(module) {

module.exports = "/_next/static/images/Iso27018Badge@2x-e33463a4afbf52e121915440fb8d2231.png";

/***/ }),

/***/ 8540:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeDataDrivenDecisions@2x-7b3d495ab828036c221de19922f35a74.png";

/***/ }),

/***/ 5987:
/***/ (function(module) {

module.exports = "/_next/static/images/UncoverKeyMoments@2x-c7a456d6a62928c2a603ceaae0882069.png";

/***/ }),

/***/ 39856:
/***/ (function(module) {

module.exports = "/_next/static/images/UseSegment@2x-f7b254f3155b77e32a8b3bf7aa32f516.png";

/***/ }),

/***/ 44098:
/***/ (function(module) {

module.exports = "/_next/static/images/DefineDetectValidate-68b1b3c79724ef8af6af4ac99b2a9834.webp";

/***/ }),

/***/ 79423:
/***/ (function(module) {

module.exports = "/_next/static/images/DefineDetectValidate@2x-abafe29817cbcbb3f86bc1f141ac6953.webp";

/***/ }),

/***/ 27871:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-1c70931d93a7237f6c5ad9cf4d90daae.webp";

/***/ }),

/***/ 2547:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-6db62c3aa64ae85736b7a0c22a981b32.webp";

/***/ }),

/***/ 43469:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroMobile-e7604c34db1ace0db8a8f9e2b241d7c8.webp";

/***/ }),

/***/ 15883:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroMobile@2x-9f018ee9d78f7c3347574d632a0f92ff.webp";

/***/ }),

/***/ 33051:
/***/ (function(module) {

module.exports = "/_next/static/images/AicpaSocBadge@2x-85c9e613dfc2024023d4708185a963e1.webp";

/***/ }),

/***/ 37326:
/***/ (function(module) {

module.exports = "/_next/static/images/DataDrivenReport-f964c241118ae2f37e6c6ee7e02bcdc7.webp";

/***/ }),

/***/ 81152:
/***/ (function(module) {

module.exports = "/_next/static/images/DataDrivenReport@2x-76a9808afb4b21d6a4fac619909a8253.webp";

/***/ }),

/***/ 55017:
/***/ (function(module) {

module.exports = "/_next/static/images/HipaaCompliantBadge@2x-c35b0b64ed8e1c9c49c5964d25019be1.webp";

/***/ }),

/***/ 65814:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeDataDrivenDecisions-bf2485756d3a6b84b859ef3572de2850.webp";

/***/ }),

/***/ 93687:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeDataDrivenDecisions@2x-9bbaeff21a42eb6c3af6743dad18cc9c.webp";

/***/ }),

/***/ 7901:
/***/ (function(module) {

module.exports = "/_next/static/images/UncoverKeyMoments-d714c2d734f700077c19c71744416a87.webp";

/***/ }),

/***/ 64300:
/***/ (function(module) {

module.exports = "/_next/static/images/UncoverKeyMoments@2x-90d8417f42c29e7042ee6894be8598df.webp";

/***/ }),

/***/ 45998:
/***/ (function(module) {

module.exports = "/_next/static/images/UseSegment-c9692791a19bf608ae5fb0dd7a7b36eb.webp";

/***/ }),

/***/ 35857:
/***/ (function(module) {

module.exports = "/_next/static/images/UseSegment@2x-f7b254f3155b77e32a8b3bf7aa32f516.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ }),

/***/ 66057:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useElementScroll; }
/* harmony export */ });
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3105);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7622);
/* harmony import */ var _events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27723);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23617);
/* harmony import */ var hey_listen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9340);






var getElementScrollOffsets = function (element) { return function () {
    return {
        xOffset: element.scrollLeft,
        yOffset: element.scrollTop,
        xMaxOffset: element.scrollWidth - element.offsetWidth,
        yMaxOffset: element.scrollHeight - element.offsetHeight,
    };
}; };
/**
 * Returns MotionValues that update when the provided element scrolls:
 *
 * - `scrollX` — Horizontal scroll distance in pixels.
 * - `scrollY` — Vertical scroll distance in pixels.
 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
 *
 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const ref = useRef()
 *   const { scrollYProgress } = useElementScroll(ref)
 *
 *   return (
 *     <div ref={ref}>
 *       <motion.div style={{ scaleX: scrollYProgress }} />
 *     </div>
 *   )
 * }
 * ```
 *
 * @public
 */
function useElementScroll(ref) {
    var values = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useConstant */ .h)(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollMotionValues */ .w);
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function () {
        var element = ref.current;
        (0,hey_listen__WEBPACK_IMPORTED_MODULE_3__/* .invariant */ .k)(!!element, "ref provided to useScroll must be passed into a HTML element.");
        if (!element)
            return;
        var updateScrollValues = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollUpdater */ .S)(values, getElementScrollOffsets(element));
        var scrollListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "scroll", updateScrollValues);
        var resizeListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "resize", updateScrollValues);
        return function () {
            scrollListener && scrollListener();
            resizeListener && resizeListener();
        };
    }, []);
    return values;
}




/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ createScrollUpdater; },
/* harmony export */   "w": function() { return /* binding */ createScrollMotionValues; }
/* harmony export */ });
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40226);


function createScrollMotionValues() {
    return {
        scrollX: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollY: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollXProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollYProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
    };
}
function setProgress(offset, maxOffset, value) {
    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
}
function createScrollUpdater(values, getOffsets) {
    var update = function () {
        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
        // Set absolute positions
        values.scrollX.set(xOffset);
        values.scrollY.set(yOffset);
        // Set 0-1 progress
        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
    };
    update();
    return update;
}




/***/ }),

/***/ 77014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCombineMotionValues; }
/* harmony export */ });
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21687);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29709);
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76432);




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useMotionValue */ .c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMultiOnChange */ .f)(values, function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(updateValue, false, true); });
    return value;
}




/***/ }),

/***/ 85770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMotionTemplate; }
/* harmony export */ });
/* harmony import */ var _use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77014);


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return (0,_use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useCombineMotionValues */ .N)(values, buildValue);
}




/***/ }),

/***/ 21687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41412);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40226);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60976);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(function () { return (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._).isStatic;
    if (isStatic) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__read */ .CR)((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}




/***/ }),

/***/ 29709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15815);



function useOnChange(value, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}




/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(1560);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs
var use_combine_values = __webpack_require__(77014);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return (0,use_combine_values/* useCombineMotionValues */.N)(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,7209,8834,4330,1382,4136,2073,8392,5735,2429,7303,948,8187,3996,7947,7960,6012,442,7079,1385,3379,814,8302,3970,9774,2888,179], function() { return __webpack_exec__(38720); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);